import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// attach admin token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("azimi_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const csrf = sessionStorage.getItem("ceo_csrf");
  if (csrf) config.headers["X-CEO-CSRF"] = csrf;
  return config;
});

// High-risk CEO actions: server answers 403 "RE-AUTHENTICATION REQUIRED…"; the mounted
// CeoReauthModal registers a handler that runs a fresh step-up, then the request is retried.
let reauthHandler = null;
let reauthInFlight = null;
export const setCeoReauthHandler = (fn) => { reauthHandler = fn; };
api.interceptors.response.use(undefined, (error) => {
  const detail = error.response?.data?.detail;
  const needsReauth = error.response?.status === 403 && typeof detail === "string" && detail.startsWith("RE-AUTHENTICATION REQUIRED");
  if (!needsReauth || !reauthHandler || error.config?._ceoRetried) return Promise.reject(error);
  reauthInFlight = reauthInFlight || reauthHandler().finally(() => { reauthInFlight = null; });
  return reauthInFlight.then(() => api.request({ ...error.config, _ceoRetried: true }));
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
